var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Offcanvas',{staticClass:"messages-offcanvas",attrs:{"config":_vm.offcanvas}},[_c('button',{staticClass:"button is-dark close-chat",on:{"click":function($event){_vm.offcanvas.isActive = false}}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v("close")])])]),_c('Chat')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }